module.exports = __webpack_public_path__ + "img/zhyly-6.9387a02e.png";